import "../../../assets/css/tabs/staffNew.css";
import "../../../assets/css/tabs/staffList.css";
import countryInformation from "../../../assets/jsonData/countryInformation.json";
import exampleProfilePhoto from "../../../assets/images/profileExample.png";
import deleteIcon from "../../../assets/images/delete.svg";

import { useCallback, useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

import { downloadMassiveStaffTemplate } from "./utils";
import { useStaffList } from "./hooks/useStaffList";
import AddStaff from "./addStaff";
import AddStaffManually from "./addStaffManually";
import ViewStaff from "./viewStaff";
import AddDocumentsModal from "./addDocuments";

function StatusButton({ isActive, onClick }) {
    return (
        <div
            className={`statusSwitch ${isActive ? "active" : ""}`}
            onClick={onClick}
        >
            <div className="statusBall"></div>
        </div>
    );
}

export default function StaffList({ supplier }) {
	// ESTADO PARA GESTIONAR EL MODAL DE AÑADIR
	const [showAddModal, setShowAddModal] = useState(false);

	// VARIABLES PARA AGREGAR MANUALMENTE EL STAFF
	const [showAddMemberModal, setShowAddMemberModal] = useState(false);

	// SelectedStaff assignment id
	const [selectedStaff, setSelectedStaff] = useState(null);

	// selectedStaff for payroll details view
	const [selectedStaffPayroll, setSelectedStaffPayroll] = useState(null);

    // Usar el custom hook para obtener la lista de staff
    const {
        data: staffList = [],
        isError,
        error,
        refetch,
		showInactiveOnly,
        entitySelected,
		handleFilterChange,
        handleSelectEntity,
		massiveStaffUpload,
		removeStaffAssignmentHandler,
		toggleStaffStatusHandler
    } = useStaffList({
        supplier
    });

	const handleShowAddModal = () => {
		setShowAddModal(true);
	}
    
	const handleMassiveStaffUpload = async (e) => {
		const file = e.target?.files[0];

		if (!file) return;

		// Usar el mutation hook
		massiveStaffUpload({
			supplierId: supplier._id,
			entityId: entitySelected._id,
			file,
		});

		// Limpiar el input
		e.target.value = '';
	}

	const handleDeleteStaff = (assignmentId) => (e) => {
		e.stopPropagation();
		
		removeStaffAssignmentHandler({ assignmentId });
	}
	
	const handleToggleStaffStatus = (assignmentId) => (e) => {
		e.stopPropagation();

		toggleStaffStatusHandler({ assignmentId });
	}

	const handleSelectStaff = (staffAssignmentId) => {
        setSelectedStaff(staffAssignmentId);
    }

	const handleRemoveSelectedStaff = useCallback(() => {
		setSelectedStaff(null);
	}, []);

	const handleSelectStaffPayroll = (e, staffAssignmentId) => {
		e.stopPropagation();
		setSelectedStaffPayroll(staffAssignmentId);
	}

	const handleRemoveSelectedStaffPayroll = useCallback(() => {
		setSelectedStaffPayroll(null);
	}, []);

    const rfcCurpLabel = countryInformation.find(country => country.code.toUpperCase() === supplier.informationCompliance.generalInformation.country.toUpperCase()).rfcCurpLabel;

    return (
		<section className="staffList">
            <Dropdown className="clientDropdown">
                <Dropdown.Toggle className={`${!entitySelected ? "default" : ""}`}>
                    {entitySelected ? entitySelected.entityName : "Select a client"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {supplier?.clients?.map((entity) => (
                        <Dropdown.Item 
                            key={entity._id} 
                            onClick={() => handleSelectEntity(entity)}>
                                {entity.clientName}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            
			<div className="addDocumentHeader">
				<h5>Staff members:</h5>
				<div className="rightOptions">
					<button className="btnBgBlueTextGradient downloadTemplate" onClick={downloadMassiveStaffTemplate}>
						Download massive staff upload .xlsx template
					</button>
					
					<div className="filterActiveStaff">
						<input
							className="supplierCheck"
							type="checkbox"
							checked={showInactiveOnly}
							onChange={handleFilterChange}
						/>
						<span className="supplierCheckText">Show inactive members</span>
					</div>
					<button disabled={!entitySelected} className="btnBgBlueTextGradient" onClick={handleShowAddModal}>Add Member</button>
				</div>
			</div>

			<table className="tableStaff">
				<thead>
					<tr>
						<th></th>
						<th><span>Name</span></th>
						<th><span>IMSS / Health Insurance Number</span></th>
						<th><span>{rfcCurpLabel}</span></th>
						<th><span></span></th>
					</tr>
				</thead>
				<tbody>
					{isError ? (
						<tr>
							<td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
								Error loading staff list: {error?.response?.data?.message || error?.message || 'Unknown error'}
								<button 
                                    style={{ justifySelf: 'center', marginTop: '10px' }}
                                    className="btnBgBlueTextGradient"
									onClick={() => refetch()} 
								>
									Retry
								</button>
							</td>
						</tr>
					) : staffList.length === 0 ? (
						<tr>
							<td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
								{entitySelected ? "No staff members found" : "Please select a client"}
							</td>
						</tr>
					) : (
						staffList.map(staff => (
							<tr key={staff._id} onClick={() => handleSelectStaff(staff.staffAssignmentId)}>
								<td>
									<div className="infoContainer">
										<img className="profilePhoto"
											src={staff.profilePhoto?.document
												? process.env.REACT_APP_URI_LOCALHOST + staff.profilePhoto?.document
												: exampleProfilePhoto}
											alt="Prodensa Supplier"
										/>
									</div>
								</td>
								<td>
									<div className="infoContainer">
										<span>{staff.name}</span>
									</div>
								</td>
								<td>
									<div className="infoContainer">
										<span>{staff.imss}</span>
									</div>
								</td>
								<td>
									<div className="infoContainer">
										<span>{staff?.curp || "N/A"}</span>
									</div>
								</td>
								<td>
									<div>
										<StatusButton
											isActive={staff.active}
											onClick={handleToggleStaffStatus(staff.staffAssignmentId)}
										/>
										<img 
											className="deleteStaff" 
											src={deleteIcon} 
											alt="Prodensa Supplier"
											onClick={handleDeleteStaff(staff.staffAssignmentId)} 
										/>
										{staff.active &&
											<OverlayTrigger
												key={`tooltip-${staff._id}`}
												placement={"top"}
												overlay={
													<Tooltip id={`tooltip-staffDocument`} className={`${staff.compliant ? "compliant" : "nonCompliant"}`}>
														{staff.compliant ? "compliant" : "nonCompliant"}
													</Tooltip>
												}
											>
												<button 
													className={`uploadDocuments ${staff.compliant ? "compliant" : "nonCompliant"}`} 
													onClick={(e) => handleSelectStaffPayroll(e, staff.staffAssignmentId)}
												/>
											</OverlayTrigger>

										}
									</div>
								</td>
							</tr>
						))
					)}
				</tbody>
			</table>

			<div className="staffsContainer d-lg-none">
				{staffList.map((staff) => (
					<div key={staff._id} className="staffInformation" onClick={() => handleSelectStaff(staff.staffAssignmentId)}>
						<div className="titleAndPhoto">
							<h5>{staff.name}</h5>
							<span>Name</span>
							<img src={
								staff?.profilePhoto?.document
									? process.env.REACT_APP_URI_LOCALHOST + staff.profilePhoto?.document
									: exampleProfilePhoto}
								alt="Prodensa Supplier"
							/>
						</div>
						<div className="imssAndRfc">
							<div>
								<h5>{staff.imss}</h5>
								<span>IMSS</span>
							</div>
							<div>
								<h5>{staff?.curp || "N/A"}</h5>
								<span>RFC/CURP</span>
							</div>
						</div>
						<div className="imssAndRfc">
							<div>
								<StatusButton
									isActive={staff.active}
									onClick={handleToggleStaffStatus(staff.staffAssignmentId)}
								/>
							</div>
						</div>
					</div>
				))}
			</div>

			<AddStaff
				showAddModal={showAddModal}
				onHide={() => setShowAddModal(false)}
				handleManuallyAddMember={() => { setShowAddModal(false); setShowAddMemberModal(true) }}
				massiveStaffUpload={handleMassiveStaffUpload}
			/>

			{showAddMemberModal &&
				<AddStaffManually
					showModal={showAddMemberModal}
					onHide={() => setShowAddMemberModal(false)}
					supplier={supplier}
					entitySelected={entitySelected}
				/>
			}

			<ViewStaff
				supplier={supplier}
				entitySelected={entitySelected}
				staffAssignmentId={selectedStaff}
				onHide={handleRemoveSelectedStaff}
				handleSelectStaffPayroll={handleSelectStaffPayroll}
			/>

			<AddDocumentsModal
				supplier={supplier}
				entitySelected={entitySelected}
				staffAssignmentId={selectedStaffPayroll}
				onHide={handleRemoveSelectedStaffPayroll}
			/>
		</section>
	);
}
